import { render, staticRenderFns } from "./add.vue?vue&type=template&id=b977f81e&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=b977f81e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b977f81e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b977f81e')) {
      api.createRecord('b977f81e', component.options)
    } else {
      api.reload('b977f81e', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=b977f81e&scoped=true", function () {
      api.rerender('b977f81e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchase/purchaseForm/add.vue"
export default component.exports